<div class="custom-web-form-container">
    <div class="header">
        <div class="title">
            Confirm your Phone Number
        </div>
        <div class="subtitle">
            Let’s get you sorted.
        </div>
    </div>
    <div>
        <app-kamona-phone-number-field [input]="phoneNumber">
        </app-kamona-phone-number-field>
    </div>
    <div class="pt-[8px]">
        <div class="kamona-desktop-button-wrapper-v2">
            <app-kamona-custom-button
                    (submitForm)="submit()"
                    [isBlock]="true"
                    [isDisabled]="!form?.valid"
                    [isSubmitting]="submitting"
                    [type]="'primary'"
                    text="Continue">
            </app-kamona-custom-button>
        </div>
    </div>
</div>
